<template>
  <v-dialog
    v-model="isVisible"
    max-width="565"
    @click:outside="$emit('onClose')"
    @keydown.esc="$emit('onClose')"
    persistent
  >
    <v-card style="background-color: #1a1a1a" class="ma-0" outlined>
      <v-row class="mr-6 ml-6 mb-6 pb-0 flex-nowrap">
        <h1 class="pa-0 mt-6">
          {{ $t("project_list.modal.share.title", { project: projectName }) }}
        </h1>
        <v-spacer />
        <v-icon @click="$emit('onClose')" class="mt-7 mr-1 flex-shrink-0">
          $iconClose
        </v-icon>
      </v-row>
      <v-tabs
        :value="tab"
        @change="(value) => (tab = value)"
        centered
        show-arrows
        background-color="#4C4C4C"
        class="pa-0 ma-0"
      >
        <v-tab>
          {{ $t("project_list.modal.share.tab.full_access") }}
        </v-tab>
        <v-tab>
          {{ $t("project_list.modal.share.tab.duplicate") }}
        </v-tab>
      </v-tabs>
      <v-row class="ma-0" justify="center">
        <v-tabs-items :value="tab">
          <v-tab-item>
            <share-full-access :projectName="projectName" />
          </v-tab-item>
          <v-tab-item>
            <share-duplication />
          </v-tab-item>
        </v-tabs-items>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import ShareFullAccess from "./ShareFullAccess";
import ShareDuplication from "./ShareDuplication";

export default {
  name: "share",
  components: { ShareFullAccess, ShareDuplication },
  props: {
    isVisible: Boolean,
    projectName: String,
  },
  data: function () {
    return {
      tab: this.$i18n.t("project_list.modal.share.tab.full_access"),
    };
  },
};
</script>

<style lang="scss" scoped>
.v-card:not(.v-sheet--tile):not(.v-card--shaped),
.theme--dark.v-tabs-items {
  border-radius: 16px;
}
.theme--dark.v-card.v-card--outlined {
  border: thin solid rgba(255, 255, 255, 0.5);
}
.v-tab {
  text-transform: none !important;
  font-weight: normal;
}
</style>
